<template>
    <div style="display: grid; grid-template-columns: auto 1fr; height: 100%">

        <!-- サイドメニュー -->
        <div style="width: 180px; min-width: 180px; background: #444468;">
            <img src="/resources/logo.png" style="margin: 8px 0 0 8px"/>
            <div class="main-menu-box" style="margin-top: 2rem;">
                <div :selected='RS.key=="search"' v-on:click="navigate('search')">予約検索</div>
            </div>
            <div class="main-menu-box" style="margin-top: 4rem;">
                <p style="border-bottom: 1px solid white"></p>
                <div v-on:click="logout">サインアウト</div>
            </div>
        </div>

        <div style="padding: 20px; min-width: 1000px;">
            <BookingSearchPage v-if='RS.key=="search"' />
        </div>
    </div>
</template>

<script>
//import { Dialog } from "../assets/dialog.js";
import { Router } from "../assets/router.js";
import { Auth } from "../assets/auth.js";
import { Dialog } from "../assets/dialog.js";

import BookingSearchPage from '../operator/pages/BookingSearchPage.vue'

//ルーティングセットアップ
Router.pages = [
    { key:"search",      path:"/visitor" },
]
Router.initialize();

//APIで認証異常の場合ログイン画面へ
Auth.onUnAuthorized = function(){
    location.href = "/login.html"
}

//ユーザーチェック
let Account = Auth.getAuthState()
if(!Account || Account.role != 2){
    Auth.onUnAuthorized()
}

export default {
    components: {
        BookingSearchPage,
    },
    data(){ return {
            RS: Router.state,
            Account: Account,
        }
    },
    async mounted() {
    },
    methods: {
        navigate : function (key) {
            Router.navigateByKey(key)
        },
        logout : async function(){
            let res = await Dialog.messageboxAsync("サインアウトします。"
                , Dialog.Messagebox_Buttons_OkCancel
                , Dialog.Messagebox_Icon_Info)
            if(!res) return
            Auth.logout()
            location.href = "/login.html"
        },
    },
};
</script>

<style scoped>
h1{
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0.5rem 0;
}
.main-menu-box>div{
    color: whitesmoke;
    padding: 10px 0 10px 16px;
    cursor: pointer;
    font-size: 1.1rem;
    transition: 200ms ease;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}
.main-menu-box>div:hover{
    background: #2a2a42;
}
.main-menu-box>div[selected]{
    background: #2a2a42;
}
</style>
